import { Link } from "react-router-dom";
import { useEffect } from "react";

export function NotFoundPage() {
  useEffect(() => {
    document.title = "404 — sonslow";
  }, []);

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 24px",
        textAlign: "center",
        gap: 18,
        position: "relative",
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 50% 40%, rgba(200,164,104,0.10) 0%, transparent 55%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          fontSize: "clamp(96px, 18vw, 200px)",
          lineHeight: 0.9,
          fontWeight: 900,
          letterSpacing: "-0.04em",
          color: "var(--accent)",
          fontVariantNumeric: "tabular-nums",
          position: "relative",
        }}
      >
        404
      </div>

      <div
        style={{
          fontSize: "clamp(18px, 2.4vw, 24px)",
          fontWeight: 700,
          color: "var(--fg)",
          maxWidth: "36ch",
          position: "relative",
        }}
      >
        Ce morceau n'existe pas dans notre catalogue.
      </div>

      <div
        style={{
          fontSize: 14,
          color: "var(--fg-mute)",
          maxWidth: "38ch",
          position: "relative",
        }}
      >
        La page que tu cherches a peut-être été renommée ou supprimée.
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 8, flexWrap: "wrap", justifyContent: "center", position: "relative" }}>
        <Link to="/" className="btn primary" style={{ padding: "10px 20px" }}>
          ← Accueil
        </Link>
        <Link to="/search" className="btn" style={{ padding: "10px 20px" }}>
          Rechercher
        </Link>
        <Link to="/library" className="btn" style={{ padding: "10px 20px" }}>
          Ma bibliothèque
        </Link>
      </div>
    </div>
  );
}
